<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import DatePicker from "vue2-datepicker";

/**
 * Contacts-grid component
 */
export default {
  page: {
    title: "Departmental Performance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,ModelListSelect,DatePicker},
  data() {
    return {
    filterData: {
        time: "all",
        dateRange: "",
    },
    select_option: {
        department: 'select',
        time: 'all',
        dateRange: 0
      },
       timeFilters: [
        { title: "Customise", value: "custom" },     
        { title: "All", value: "all" },
        { title: "Today", value: "today" },
        { title: "Yesterday", value: "yesterday" },
        { title: "Last 7 days", value: "last7" },
        { title: "Last 14 days", value: "last14" },
        { title: "Last 28 days", value: "last28" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
      ],

      title: "Departmental Performance",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Departmental Performance",
          active: true,
        },
      ],
      perPage: 10,
      filterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      pageOptions: [10, 25, 50, 100, 200, 1000],
      currentPage: 1,
      filter: null,
      filtered_data: [],
      json_fields: {
        STAFF_NAME: "staffName",
        STAFF_CONTACT: "staffContact",
        STAFF_EMAIL: "staffEmail",
        STAFF_ADDRESS: "staffAddress",
        STAFF_GENDER: "staffGenderName",
        POSITION: "position_name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("reports", ["graphsData"]),
    ...mapGetters("reports", ["graphData"]),
    ...mapGetters("reports", ["DepgraphData"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filtered_data ? this.filtered_data.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_data ? this.filtered_data.length : 1;
  },
  watch: {
    graphData(newValue) {
      if (newValue) {        
        this.SetData();
      }
    },
    DepgraphData(newValue) {
      if (newValue) {
        return this.DepgraphData;
      }
    }
  },
  methods: {
    ...mapActions({
      FetchGraph: "reports/fetchGraph",
      FetchDepartmentGraph: "reports/fetchdepartmentGraph",
    }),
    SetData() {
        if(!this.filtered_data.length && this.graphData.Consultation){
         this.filtered_data.push(this.graphData);        }           
    },
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setDepLabel() {
      if (this.select_option.time == "today") {
        this.graphLabel = "today";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "yesterday") {
        this.graphLabel = "yesterday";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "last7") {
        this.graphLabel = "in last 7 days";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "last14") {
        this.graphLabel = "in last 14 days";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "last28") {
        this.graphLabel = "in last 28 days";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "month") {
        this.graphLabel = "in this month";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "quarter") {
        this.graphLabel = "in this quarter";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "all") {
        this.graphLabel = "for all time";
        this.select_option.dateRange = "";
      }
      if (this.select_option.time == "custom") {
        this.graphLabel = "";
        this.select_option.dateRange = "";
      }
    },

    FilterDash() {
      if (this.filterData.time == "custom" && this.filterData.dateRange == "") {
        return;
      }
      if (
        this.filterData.time == "custom" &&
        this.filterData.dateRange[0] == null &&
        this.filterData.dateRange[1] == null
      ) {
        return;
      }
      this.FetchGraph(this.filterData);
    },

    FetchDep(dep){
      if(dep){
        this.select_option.department = dep;
        this.FetchDepartmentGraph(this.select_option)  
      }else{
        this.FetchDepartmentGraph(this.select_option)  
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

  },
  created() {    
    this.FetchGraph(this.filterData);
     this.SetData();
 
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" /> 
    <div class="card">
        <div class="card-body">
          <div class="row"> 
            <div class="col-md-3 mt-4"> 
              <router-link to="/reports/departmental_performance"><button class="btn btn-success"><i class="fa fa-list"></i>Graphic View</button></router-link>
            </div>
            <div v-if="select_option.department == 'select'" class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="filterData.time"
                option-value="value"
                size="sm"
                @input="
                  FilterDash();
                  setLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-else class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="select_option.time"
                option-value="value"
                size="sm"
                @input="
                  FetchDep();
                  setDepLabel();                  
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-if="select_option.department == 'select' && filterData.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="filterData.dateRange"
                range
                append-to-body
                @change="FilterDash"
                lang="en"
                confirm
              ></date-picker>
            </div>
            <div v-if="select_option.department != 'select' && select_option.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="select_option.dateRange"
                range
                append-to-body
                @change="FetchDep"
                lang="en"
                confirm
              ></date-picker>
            </div>     
          </div>
        </div>
      </div>
 <div>
  <div class="row mt-4">
              <div class="col-md-6 mb-2">
                <b-button variant="primary" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <!-- Search -->
              <div class="col-md-6" v-if="DepgraphData[0]?true:false">
                <b-button class="float-end" variant="primary" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="row">
            <div class="col-md-5 table-responsive mb-0">
              <table border="1" style="width:100%;">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Departments</th>
                        <th>Total Sales</th>
                        <th>Details</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Consultation</td>
                        <td>{{thousandSeprator(graphData.Consultation)}}</td>
                        <td>
                          <button @click="FetchDep('Consultation')" class="btn btn-link">View</button>
                        </td>
                    </tr> 
                    <tr>
                        <td>2</td>
                        <td>Radiology</td>
                        <td>{{thousandSeprator(graphData.Radiology)}}</td>
                        <td>
                          <button @click="FetchDep('Radiology')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Procedure</td>
                        <td>{{thousandSeprator(graphData.Procedure)}}</td>
                        <td>
                          <button @click="FetchDep('Procedure')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Laboratory</td>
                        <td>{{thousandSeprator(graphData.Laboratory)}}</td>
                        <td>
                          <button @click="FetchDep('Laboratory')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Dental</td>
                        <td>{{thousandSeprator(graphData.Dental)}}</td>
                        <td>
                          <button @click="FetchDep('Dental')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Antenantal</td>
                        <td>{{thousandSeprator(graphData.Antenantal)}}</td>
                        <td>
                          <button @click="FetchDep('Antenantal')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>Inpatient</td>
                        <td>{{thousandSeprator(graphData.Inpatient)}}</td>
                        <td>
                          <button @click="FetchDep('Inpatient')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Pharmacy</td>
                        <td>{{thousandSeprator(graphData.Pharmacy)}}</td>
                        <td>
                          <button @click="FetchDep('Pharmacy')" class="btn btn-link">View</button>
                        </td>
                    </tr>
                </tbody>
              </table>              
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-5 table-responsive mb-0" v-if="DepgraphData[0]?true:false">
              <table style="width:100%" v-if="DepgraphData[0].name">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Service</th>
                        <th>Total Sales</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="DepgraphData[0]">
                        <td>1</td>
                        <td>{{DepgraphData[0]?DepgraphData[0].name:''}}</td>
                        <td>{{DepgraphData[0]?thousandSeprator(DepgraphData[0].total):''}}</td>
                    </tr> 
                    <tr v-if="DepgraphData[1]">
                        <td>2</td>
                        <td>{{DepgraphData[1]?DepgraphData[1].name:''}}</td>
                        <td>{{DepgraphData[1]?thousandSeprator(DepgraphData[1].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[2]">
                        <td>3</td>
                        <td>{{DepgraphData[2]?DepgraphData[2].name:''}}</td>
                        <td>{{DepgraphData[2]?thousandSeprator(DepgraphData[2].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[3]">
                        <td>4</td>
                        <td>{{DepgraphData[3]?DepgraphData[3].name:''}}</td>
                        <td>{{DepgraphData[3]?thousandSeprator(DepgraphData[3].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[4]">
                        <td>5</td>
                        <td>{{DepgraphData[4]?DepgraphData[4].name:''}}</td>
                        <td>{{DepgraphData[4]?thousandSeprator(DepgraphData[4].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[5]">
                        <td>6</td>
                        <td>{{DepgraphData[5]?DepgraphData[5].name:''}}</td>
                        <td>{{DepgraphData[5]?thousandSeprator(DepgraphData[5].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[6]">
                        <td>7</td>
                        <td>{{DepgraphData[6]?DepgraphData[6].name:''}}</td>
                        <td>{{DepgraphData[6]?thousandSeprator(DepgraphData[6].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[7]">
                        <td>8</td>
                        <td>{{DepgraphData[7]?DepgraphData[7].name:''}}</td>
                        <td>{{DepgraphData[7]?thousandSeprator(DepgraphData[7].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[8]">
                        <td>9</td>
                        <td>{{DepgraphData[8]?DepgraphData[8].name:''}}</td>
                        <td>{{DepgraphData[8]?thousandSeprator(DepgraphData[8].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[9]">
                        <td>10</td>
                        <td>{{DepgraphData[9]?DepgraphData[9].name:''}}</td>
                        <td>{{DepgraphData[9]?thousandSeprator(DepgraphData[9].total):''}}</td>
                    </tr>
                </tbody>
              </table>
              <table style="width:100%" v-if="DepgraphData[0].drug">
                <thead>
                    <tr>
                        <th>S/No.</th>
                        <th>Service</th>
                        <th>Total Sales</th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-if="DepgraphData[0]">
                        <td>1</td>
                        <td>{{DepgraphData[0]?DepgraphData[0].drug:''}}</td>
                        <td>{{DepgraphData[0]?thousandSeprator(DepgraphData[0].total):''}}</td>
                    </tr> 
                    <tr v-if="DepgraphData[1]">
                        <td>2</td>
                        <td>{{DepgraphData[1]?DepgraphData[1].drug:''}}</td>
                        <td>{{DepgraphData[1]?thousandSeprator(DepgraphData[1].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[2]">
                        <td>3</td>
                        <td>{{DepgraphData[2]?DepgraphData[2].drug:''}}</td>
                        <td>{{DepgraphData[2]?thousandSeprator(DepgraphData[2].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[3]">
                        <td>4</td>
                        <td>{{DepgraphData[3]?DepgraphData[3].drug:''}}</td>
                        <td>{{DepgraphData[3]?thousandSeprator(DepgraphData[3].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[4]">
                        <td>5</td>
                        <td>{{DepgraphData[4]?DepgraphData[4].drug:''}}</td>
                        <td>{{DepgraphData[4]?thousandSeprator(DepgraphData[4].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[5]">
                        <td>6</td>
                        <td>{{DepgraphData[5]?DepgraphData[5].drug:''}}</td>
                        <td>{{DepgraphData[5]?thousandSeprator(DepgraphData[5].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[6]">
                        <td>7</td>
                        <td>{{DepgraphData[6]?DepgraphData[6].drug:''}}</td>
                        <td>{{DepgraphData[6]?thousandSeprator(DepgraphData[6].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[7]">
                        <td>8</td>
                        <td>{{DepgraphData[7]?DepgraphData[7].drug:''}}</td>
                        <td>{{DepgraphData[7]?thousandSeprator(DepgraphData[7].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[8]">
                        <td>9</td>
                        <td>{{DepgraphData[8]?DepgraphData[8].drug:''}}</td>
                        <td>{{DepgraphData[8]?thousandSeprator(DepgraphData[8].total):''}}</td>
                    </tr>
                    <tr v-if="DepgraphData[9]">
                        <td>10</td>
                        <td>{{DepgraphData[9]?DepgraphData[9].drug:''}}</td>
                        <td>{{DepgraphData[9]?thousandSeprator(DepgraphData[9].total):''}}</td>
                    </tr>
                </tbody>
              </table>
            </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
 </div>
    <!-- end row -->
  </Layout>
</template>
<style>
table, th, td {
  border: 1px solid;
}
</style>